import { createStyles, Group, Paper } from '@mantine/core';
import Cookies from 'js-cookie';
import useTranslation from 'next-translate/useTranslation';
import { useCallback, useEffect, useState } from 'react';

import { Button } from '~/domains/design-system/Button';
import { Text } from '~/domains/design-system/Text';

const useStyles = createStyles((theme) => ({
  content: {
    backgroundColor: theme.colors.yellow[2],
  },
}));

function LocationDisallowedSingleStatBanner({ state }: { state: string }) {
  const { classes, theme } = useStyles();
  const { t } = useTranslation('contest');
  const [isDismissed, setIsDismissed] = useState(
    Cookies.get('quickPickDisallowedSingleStatBanner') === 'true'
  );

  const handleDismiss = useCallback(() => {
    Cookies.set('quickPickDisallowedSingleStatBanner', 'true');
    setIsDismissed(true);
  }, []);

  if (isDismissed) {
    return null;
  }

  return (
    <Paper
      radius="md"
      className={classes.content}
      px={theme.other.spacing._16}
      py={theme.other.spacing._12}
    >
      <Group align="center" position="apart" noWrap>
        <Text variant="title-small">
          {t('quickPick.locationInfo.disallowedSingleStatCopy', { state })}
        </Text>
        <Button variant="secondary-fill" size="small" onClick={handleDismiss}>
          <Text variant="subhead-small">
            {t('quickPick.locationInfo.disallowedSingleStatButton')}
          </Text>
        </Button>
      </Group>
    </Paper>
  );
}

export default LocationDisallowedSingleStatBanner;
